import { observer } from 'mobx-react-lite'

import { Toolbar } from '#components/Toolbar'
import { useMst } from '#state'

export const HyperlinkButton = observer(function HyperlinkButton() {
  const { currentScript } = useMst()
  if (!currentScript?.observableEditor) {
    return null
  }

  const { readOnlyByPlan } = currentScript
  const disabled =
    readOnlyByPlan || !currentScript.observableEditor.hyperlinkingEnabled
  const tooltip = readOnlyByPlan
    ? 'Editing is disabled on your current plan'
    : disabled
      ? 'Select text to insert a link'
      : 'Insert link'

  const handleClick = () => {
    currentScript?.observableEditor?.setEditingHyperlink(true)
  }

  return (
    <Toolbar.Button
      icon="fa-link"
      tooltip={tooltip}
      onClick={handleClick}
      disabled={disabled}
    />
  )
})
